import React, { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import styles from './Modal.module.css';

interface ModalProps {
  children: ReactNode;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ children, onClose }) => {
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <IconButton
        aria-label="close"
        onClick={onClose}
        className={styles.modalCloseButton}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={styles.modalContent}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal; 